import { Button, Input } from '@fsd/ui';
import { AddSquare, CloseCircle } from '@solar-icons/react';
import type { LocalizedStringArray } from '../../types/product';

interface FeaturesListProps {
  features: LocalizedStringArray;
  onChange: (features: LocalizedStringArray) => void;
  lang: 'pt-BR' | 'en-US' | 'es-ES';
}

export function FeaturesList({ features, onChange, lang }: FeaturesListProps) {
  const addFeature = () => {
    onChange({
      'pt-BR': [...features['pt-BR'], ''],
      'en-US': [...features['en-US'], ''],
      'es-ES': [...features['es-ES'], ''],
    });
  };

  const removeFeature = (index: number) => {
    onChange({
      'pt-BR': features['pt-BR'].filter((_, i) => i !== index),
      'en-US': features['en-US'].filter((_, i) => i !== index),
      'es-ES': features['es-ES'].filter((_, i) => i !== index),
    });
  };

  const updateFeature = (index: number, value: string) => {
    const newFeatures = { ...features };
    newFeatures[lang][index] = value;
    onChange(newFeatures);
  };

  const currentFeatures = features[lang];

  return (
    <div className="space-y-3">
      <span className="text-sm font-medium text-foreground block">Características/Features</span>
      <div className="space-y-2 pt-2">
        {currentFeatures.length === 0 ? (
          <div className="text-center py-8 bg-muted rounded-md border border-dashed border-border">
            <p className="text-sm text-muted-foreground">Nenhuma característica adicionada</p>
          </div>
        ) : (
          currentFeatures.map((_, index) => (
            <div
              key={`feature-${lang}-${
                // biome-ignore lint/suspicious/noArrayIndexKey: Index is used as key
                index
              }`}
              className="flex gap-2 items-center"
            >
              <span className="text-sm text-muted-foreground w-6">{index + 1}.</span>
              <Input
                value={features[lang][index]}
                onChange={(e) => updateFeature(index, e.target.value)}
                placeholder={
                  lang === 'pt-BR'
                    ? 'Ex: Bateria de longa duração'
                    : lang === 'en-US'
                      ? 'Ex: Long-lasting battery'
                      : 'Ex: Batería de larga duración'
                }
                className="flex-1"
              />
              <Button type="button" variant="ghost" size="sm" onClick={() => removeFeature(index)}>
                <CloseCircle size={16} />
              </Button>
            </div>
          ))
        )}
      </div>

      <Button type="button" variant="outline" size="sm" onClick={addFeature}>
        <AddSquare size={16} className="mr-2" />
        Adicionar Característica
      </Button>
    </div>
  );
}
